import gql from 'graphql-tag'

export default
gql`mutation putUser($input: ID!){
		putUser(input:$input){
			id
		}
	}
`



// WEBPACK FOOTER //
// ./src/components/mutations/PutUserMutation.js